




























































































































































































































































































































































































































import { types } from '../../store/types/types.js';
import { presenceStates } from '../../../shared/enums/presenceStates';
import { exitTypes } from '../../../shared/enums/exitTypes';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import UpdateChildrenStatusForm from './UpdateChildrenStatusForm.vue';
import Vue from 'vue';
import $ from 'jquery';
import { activityListSortTypes } from '../../../shared/enums/activityListSortTypes.js';
import { orderDirections } from '../../../shared/enums/orderDirections.js';
import { parentTypes } from '../../../shared/enums/parentTypes.ts';
import { presenceModules } from '../../../shared/enums/presenceModules.js';
import { presenceModuleStatus } from '../../../shared/enums/presenceModuleStatus.js';
import { presenceDashboardContext } from '../../../shared/enums/presenceDashboardContext.js';
import AulaImg from '../../../shared/components/AulaImg.vue';
import AulaButtons from '../../../shared/components/AulaButtons.vue';
import AulaButton from '../../../shared/components/AulaButton.vue';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import Button from '../../../shared/directives/button.js';
import { useUserProfileStore } from '../../../shared/stores';
import { UniStudentActivityModel } from '../../../shared/models/uniStudentActivity.model';

export default {
  directives: { Button },
  data: function () {
    return {
      Vue: Vue,
      exitTypes: exitTypes,
      orderDirections: orderDirections,
      presenceStates: presenceStates,
      activityListSortTypes: activityListSortTypes,
      isLoading: false,
      isLoadingMore: false,
      activityPerPage: 20,
      activeSort: activityListSortTypes.NEXT_ACTIVITY_DATE,
      showAllActivities: false,
      selectedActivity: null,
      selectedRegistrationIds: [],
      isEditingMode: false,
      compatibleRegistrationsToUpdate: [],
      incompatibleRegistrationsToUpdate: [],
      incompatibleRegistrationNames: [],
      changedStatus: null,
      checkAllRegistration: false,
      reloadInterval: null,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: types.GET_IS_MOBILE,
      institutions: types.GET_INSTITUTIONS,
      activeInstitutions: types.GET_ACTIVE_INSTITUTIONS,
      getPresenceFilters: types.GET_PRESENCE_FILTERS,
      activityList: types.GET_ACTIVITY_LIST,
      hasMoreActivity: types.GET_HAS_MORE_ACTIVITY,
      departments: types.GET_DEPARTMENTS,
      selectedDepartment: types.GET_SELECTED_DEPARTMENT,
      filterOptions: types.GET_FILTER_OPTIONS,
      states: types.GET_PRESENCE_STATES,
      activities: types.GET_PRESENCE_ACTIVITIES,
      getDepartments: types.GET_DEPARTMENTS,
      presenceConfiguration: types.GET_PRESENCE_CONFIGURATION,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    getStatistic() {
      let statistic = '';
      if (this.isEditingMode) {
        statistic = this.$getText('PRESENCE_DASHBOARD_SELECTED_STATISTIC', {
          numberOfSelected: this.selectedRegistrationIds.length,
          numberOfChildren: this.activityList.totalNumberOfChildren,
        });
      } else {
        statistic = this.$getText('PRESENCE_DASHBOARD_NO_STATISTIC');
        let cleanFilters = true;
        if (
          this.filterOptions.groupId != null ||
          this.filterOptions.activityType != null ||
          this.filterOptions.status != null
        ) {
          cleanFilters = false;
        }
        if (!cleanFilters) {
          statistic = this.$getText('PRESENCE_DASHBOARD_STATISTIC_WITH_FILTERING', {
            totalNumberOfChildren: this.activityList.totalNumberOfChildren,
          });
        } else {
          if (
            this.activityList != null &&
            this.activityList.numberOfChildrenPresent != null &&
            this.activityList.totalNumberOfChildren != null
          ) {
            statistic = this.$getText('PRESENCE_DASHBOARD_STATISTIC', {
              numberOfChildrenPresent: this.activityList.numberOfChildrenPresent,
              totalNumberOfChildren: this.activityList.totalNumberOfChildren,
            });
          }
        }
      }
      return statistic;
    },
    chosenDepartment() {
      return this.getDepartments.find(d => d.id === this.filterOptions.departmentId);
    },
    shouldShowDailyNote() {
      const currentActivity = this.selectedActivity;
      const isOnVacation = currentActivity.presenceState === presenceStates.REPORTED_ABSENT;
      return (currentActivity.comment && !isOnVacation) || (!currentActivity.note && isOnVacation);
    },
  },

  methods: {
    ...mapActions({
      loadActivityList: types.LOAD_ACTIVITY_LIST,
      reloadActivityList: types.RELOAD_ACTIVITY_LIST,
      loadPresenceFilters: types.LOAD_PRESENCE_FILTER,
      updateSelectedChildrenStatus: types.UPDATE_SELECTED_CHILDREN_STATUS,
      loadPresenceConfiguration: types.LOAD_PRESENCE_CONFIGURATION,
    }),
    ...mapMutations({
      updateFilterOptions: types.MUTATE_FILTER_OPTIONS,
      setSelectedRegistrations: types.MUTATE_SELECTED_REGISTRATION_TO_EDIT,
    }),
    getActivityNoteHeader(activity: UniStudentActivityModel) {
      switch (activity.presenceState) {
        case presenceStates.REPORTED_ABSENT:
          return this.$t('presence.vacation_free_time_note');
        default:
          return this.$t('presence.spare_time_activity_note');
      }
    },
    getActivityHasContentOnRightSide(activity) {
      const hasComment = activity.comment || activity.note;
      const isEditing = this.isEditingMode;
      const isEmphasized = activity.isEmphasized;
      return hasComment || isEditing || isEmphasized;
    },
    viewChildContact(id) {
      this.$router.push({
        name: 'userview',
        params: { id: id },
        query: { parent: parentTypes.PRESENCE },
      });
    },
    getSortCss(sortType) {
      return this.activeSort == sortType ? this.filterOptions.orderDirection : '';
    },
    getActivityLabelName(activity, futureOrPastActivity) {
      if (
        futureOrPastActivity.activityType === exitTypes.DROP_OFF_TIME &&
        activity.isDefaultEntryTimes &&
        !futureOrPastActivity.checkinTime
      ) {
        return this.$getText('PRESENCE_ENTRY_TIME_NOT_SET');
      } else if (activity.isDefaultExitTimes && !futureOrPastActivity.checkoutTime) {
        if (futureOrPastActivity.activityType === exitTypes.PICKED_UP_BY && futureOrPastActivity.exitWith) {
          return this.$getText('PRESENCE_EXIT_TIME_NOT_SET_PICKED_UP_BY', {
            exitWith: futureOrPastActivity.exitWith,
          });
        } else if (futureOrPastActivity.activityType === exitTypes.PICKED_UP_BY && !futureOrPastActivity.exitWith) {
          return this.$getText('PRESENCE_EXIT_TIME_NOT_SET_PICKED_UP_BY_UNDEFINED');
        } else if (futureOrPastActivity.activityType === exitTypes.GO_HOME_WITH) {
          return this.$getText('PRESENCE_EXIT_TIME_NOT_SET_GO_HOME_WITH', {
            exitWith: futureOrPastActivity.exitWith,
          });
        } else if (
          futureOrPastActivity.activityType === exitTypes.SEND_HOME ||
          futureOrPastActivity.activityType === exitTypes.SELF_DECIDER
        ) {
          return this.$getText('PRESENCE_EXIT_TIME_NOT_SET');
        }
      }

      return futureOrPastActivity.label;
    },
    changeDrawerShow(isShowed) {
      this.$router.push({ name: 'presenceEmployee' });
      if (!isShowed) {
        this.loadActivities(false);
      }
    },
    showEditingModal(presenceRegistrationId = null) {
      let selectedRegistrations = [];
      if (presenceRegistrationId) {
        selectedRegistrations = this.activityList.activities.filter(
          a => presenceRegistrationId == a.presenceRegistrationId
        );
      } else {
        selectedRegistrations = this.activityList.activities.filter(a =>
          this.selectedRegistrationIds.includes(a.presenceRegistrationId)
        );
      }
      this.setSelectedRegistrations({
        selectedRegistrations: selectedRegistrations,
      });
      this.$refs.updateChildrenStatusForm.show();
    },
    getActivityCssClass(activity) {
      let cssClass = 'activity-data';
      if (activity.presenceState === presenceStates.PHYSICAL_PLACEMENT) {
        cssClass += ' physical-placement';
      }
      for (const groupStatus of this.states) {
        for (const status of groupStatus.options) {
          if (activity.presenceState === status.value) {
            cssClass += ' ' + status.class;
          }
        }
      }
      return cssClass;
    },
    sortUpdated(sortType, orderDirection) {
      this.activeSort = sortType;
      this.updateFilterOptions({
        activityListSort: sortType,
        orderDirection: orderDirection,
      });
    },
    refreshActivityList() {
      this.loadActivities(false);
    },
    resetEditMode() {
      this.isEditingMode = false;
      this.checkAllRegistration = false;
      this.selectedRegistrationIds = [];
    },
    cancelEdit() {
      this.resetEditMode();
      this.$router.push({ name: 'presenceEmployee' });
    },
    checkedAllChildren(allSelected) {
      this.checkAllRegistration = !this.checkAllRegistration;
      if (allSelected) {
        this.selectedRegistrationIds = [...new Set(this.activityList.activities.map(u => u.presenceRegistrationId))];
      } else {
        this.selectedRegistrationIds = [];
      }
    },
    updateStatus() {
      if (this.compatibleRegistrationsToUpdate.length > 0) {
        const params = {
          presenceRegistrationIds: [
            ...new Set(this.compatibleRegistrationsToUpdate.map(r => r.presenceRegistrationId)),
          ],
          status: this.changedStatus,
        };
        this.updateSelectedChildrenStatus(params).then(() => {
          this.isEditingMode = false;
          this.selectedRegistrationIds = [];

          this.loadActivities(false);
        });
      } else {
        this.isEditingMode = false;
        this.selectedRegistrationIds = [];
      }
    },
    showPresenceState(activity) {
      const presenceState: any = {};
      if (this.canShowPresenceState(activity)) {
        if (activity.location != null && activity.presenceState === presenceStates.PHYSICAL_PLACEMENT) {
          presenceState.label = activity.location.name;
          presenceState.icon = activity.location.symbol;
          presenceState.class = 'physical-placement';
        } else {
          for (const groupStatus of this.states) {
            for (const status of groupStatus.options) {
              if (activity.presenceState === status.value) {
                presenceState.label = status.label;
                presenceState.icon = status.icon;
                presenceState.class = status.class;
              }
            }
          }
        }
      }
      return presenceState;
    },
    getActivities(activity) {
      const activities = { pastActivities: [], futureActivities: [] };
      for (const pastActivity of activity.pastActivities) {
        pastActivity.label = this.calculateActivityLabel(pastActivity, true);
        activities.pastActivities.push(pastActivity);
      }
      for (const futureActivity of activity.futureActivities) {
        futureActivity.label = this.calculateActivityLabel(futureActivity, false);
        activities.futureActivities.push(futureActivity);
      }
      return activities;
    },
    calculateActivityLabel(activity, isPast) {
      let label = '';
      if (this.activities.find(act => act.value === activity.activityType) != null) {
        label = isPast
          ? this.activities.find(act => act.value === activity.activityType).labelPast
          : this.activities.find(act => act.value === activity.activityType).label;
      }
      if (activity.activityType === exitTypes.DROP_OFF_TIME || activity.activityType === exitTypes.CHECK_IN) {
        if (isPast) {
          label = label + ' ' + this.$getText('AT') + ' ' + activity.checkinTime;
        } else {
          label = label + ' ' + this.$getText('AT') + ' ' + activity.entryTime;
        }
      }
      if (activity.activityType === exitTypes.SPARE_TIME) {
        label =
          this.$getText('PRESENCE_STATE_SPARE_TIME_ACTIVITY') +
          ' ' +
          this.$getText('AT') +
          ' ' +
          activity.startTime +
          ' - ' +
          activity.endTime;
      }
      if (activity.activityType === exitTypes.SLEEPING) {
        label =
          this.$getText('PRESENCE_STATE_SLEEPING_PAST') +
          ' ' +
          this.$getText('AT') +
          ' ' +
          activity.startTime +
          ' - ' +
          activity.endTime;
      }
      if (activity.activityType === exitTypes.PICKED_UP_BY || activity.activityType === exitTypes.GO_HOME_WITH) {
        if (isPast) {
          label += ' ' + this.$getText('AT') + ' ' + activity.checkoutTime;
        } else {
          const labelWithoutExitWith =
            activity.activityType === exitTypes.PICKED_UP_BY
              ? this.$getText('PRESENCE_ACTIVITY_PICKED_UP')
              : this.$getText('PRESENCE_ACTIVITY_GO_HOME');
          label =
            (activity.exitWith ? label + ': ' + activity.exitWith : labelWithoutExitWith) +
            ' ' +
            this.$getText('AT') +
            ' ' +
            activity.exitTime;
        }
      }
      if (activity.activityType === exitTypes.SEND_HOME) {
        if (isPast) {
          label += ' ' + this.$getText('AT') + ' ' + activity.checkoutTime;
        } else {
          label += ': ' + this.$getText('AT') + ' ' + activity.exitTime;
        }
      }
      if (activity.activityType === exitTypes.SELF_DECIDER) {
        if (isPast) {
          label += ' ' + this.$getText('AT') + ' ' + activity.checkoutTime;
        } else {
          label =
            this.$getText('PRESENCE_PICKUP_TYPE_SELF_DECIDER') +
            ': ' +
            this.$getText('AT') +
            ' ' +
            activity.selfDeciderStartTime +
            ' - ' +
            activity.selfDeciderEndTime;
        }
      }
      return label;
    },
    toggleAllActivities(activity) {
      if (activity.showAll == null) {
        activity.showAll = true;
      } else {
        activity.showAll = !activity.showAll;
      }
      this.$forceUpdate();
    },
    toggleAllRows() {
      this.showAllActivities = !this.showAllActivities;
      for (const activity of this.activityList.activities) {
        activity.showAll = this.showAllActivities;
      }
      this.$forceUpdate();
    },
    reloadActivities() {
      if (this.activityList.activities != null && this.departments.length > 0 && !this.isEditingMode) {
        this.loadPresenceFilters({
          institutionCodes: this.activeInstitutions,
        }).then(() => {
          this.reloadActivityList();
        });
      }
    },
    closeUpdateStatusForm() {
      this.resetEditMode();
      this.loadActivities(false);
    },
    loadActivities(loadMore, loadAll = false) {
      this.isLoading = !loadMore;
      this.loadPresenceConfiguration({
        institutionCode: this.chosenDepartment.institutionCode,
      }).then(() => {
        this.loadActivityList({ loadMore: loadMore, loadAll: loadAll }).then(() => {
          if (this.showAllActivities) {
            this.activityList.activities.map(activity => {
              activity.showAll = this.showAllActivities;
            });
          }

          if (this.checkAllRegistration === true) {
            this.checkedAllChildren(true);
          }

          this.isLoading = false;
          this.isLoadingMore = false;
        });
      });
    },
    changeActivityTypeFilter(activityType = null) {
      this.filterOptions.activityType = activityType;
      this.changeFilter();
    },
    changeFilter() {
      this.loadActivities(false);
    },
    handleScroll() {
      if (this.hasMoreActivity && !this.isLoadingMore && !this.isLoading) {
        const scrollDiv = $('#activityList');
        if (scrollDiv.length > 0) {
          const scrollHeight = $(window).scrollTop() + $(window).height();
          const contentHeight = scrollDiv.offset().top + scrollDiv.height();
          if (scrollHeight >= contentHeight) {
            this.isLoadingMore = true;
            this.loadActivities(true);
          }
        }
      }
    },
    showComment(activity) {
      this.selectedActivity = activity;
      this.$refs.selectedActivity.show();
    },
    canShowPresenceState(activity) {
      const settingsDashboard = this.presenceConfiguration.dashboardModuleSettings.find(
        setting => setting.presenceDashboardContext === presenceDashboardContext.EMPLOYEE_DASHBOARD
      );
      let presenceModule = null;
      switch (activity.presenceState) {
        case presenceStates.FIELDTRIP:
          presenceModule = settingsDashboard.presenceModules.find(
            presenceModule => presenceModule.moduleType === presenceModules.FIELD_TRIP
          );
          break;
        case presenceStates.SPARE_TIME_ACTIVITY:
          presenceModule = settingsDashboard.presenceModules.find(
            presenceModule => presenceModule.moduleType === presenceModules.SPARE_TIME_ACTIVITY
          );
          break;
      }

      if (presenceModule !== null) {
        return presenceModule.permission !== presenceModuleStatus.DEACTIVATED;
      }

      return true;
    },
  },
  watch: {
    filterOptions: {
      handler() {
        if (this.filterOptions.departmentId) {
          this.loadActivities(false);
        }
      },
      deep: true,
    },
    'filterOptions.activityListSort'() {
      this.activeSort = this.filterOptions.activityListSort;
    },
    selectedRegistrationIds() {
      if (this.selectedRegistrationIds.length == this.activityList.totalNumberOfChildren) {
        this.checkAllRegistration = true;
      } else {
        this.checkAllRegistration = false;
      }
    },
  },
  mounted() {
    if (this.filterOptions.departmentId) {
      this.loadActivities(false);
    }
    window.addEventListener('scroll', this.handleScroll);

    if (this.reloadInterval != null) {
      clearInterval(this.reloadInterval);
    }

    this.reloadInterval = setInterval(() => {
      this.reloadActivities();
    }, 600000);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  },
  components: {
    Icon,
    AulaButton,
    AulaButtons,
    AulaImg,
    UpdateChildrenStatusForm,
  },
};
